
import { DefaultState } from 'store/types';

export const REACTIVATE_ROOM_REQUEST = 'REACTIVATE_ROOM_REQUEST';
export const REACTIVATE_ROOM_SUCCESS = 'REACTIVATE_ROOM_SUCCESS';
export const REACTIVATE_ROOM_FAILURE = 'REACTIVATE_ROOM_FAILURE';

export interface ReactivateRoomData {};

export type ReactivateRoomState = DefaultState & {
  contents?: ReactivateRoomData;
};

interface ReactivateRoomDataRequest {
  type: typeof REACTIVATE_ROOM_REQUEST;
};

interface ReactivateRoomDataSuccess {
  type: typeof REACTIVATE_ROOM_SUCCESS,
  contents: ReactivateRoomData;
}

interface ReactivateRoomDataFailure {
  type: typeof REACTIVATE_ROOM_FAILURE;
}

export type ReactivateRoomActionTypes = ReactivateRoomDataRequest | ReactivateRoomDataSuccess | ReactivateRoomDataFailure;